package com.nonopn.skywatcher.design.widgets.abslists

data class ListModelStateHolder<E>(
    val state: ListModelState = ListModelState.DEFAULT,
    val objects: List<E> = emptyList(),
    val predicate: ((entity: E) -> Boolean)? = null,
    val filtered: List<E> = emptyList()
)
